type Candidate = {
  artist_id?: unknown;
  id?: unknown;
  name?: unknown;
  name_en?: unknown;
  artist_name?: unknown;
  artist_name_en?: unknown;
};

const normalizeName = (value: unknown): string =>
  String(value ?? '').normalize('NFKC').replace(/\s+/gu, '').toLowerCase();

// The casting catalog API returns the complete list; selection owns search and paging.
export function selectManualArtistCandidatePage<T extends Candidate>(
  candidates: T[], query: string, page: number, excludedIds: Set<string>,
): { artists: T[]; hasNext: boolean } {
  const keyword = normalizeName(query);
  const matches = candidates.filter((artist) => {
    const id = String(artist?.artist_id || artist?.id || '').trim();
    return id && !excludedIds.has(id) && (!keyword ||
      [artist.name, artist.name_en, artist.artist_name, artist.artist_name_en]
        .some((name) => normalizeName(name).includes(keyword)));
  });
  const offset = Math.max(0, page) * 50;
  return { artists: matches.slice(offset, offset + 50), hasNext: matches.length > offset + 50 };
}
